import React from 'react'
import _ from "lodash"
import CRUD from "../../../Shared/enums/CRUD";
import {renderIf, renderIfElse} from "../../../Shared";
import {IoHeartOutline, IoHeartSharp} from "react-icons/io5";
import {GiSpellBook} from "react-icons/gi";
import {HeaderButton} from "../../../Organization/components/PageHeader";
import useTranslate from "../../../../modules/local/useTranslate";
import {FiEdit3} from "react-icons/fi";
import {BiTrash} from "react-icons/bi";
import getLinkToDetail from 'helpers/getLinkToDetail'
import {Link} from "react-router-dom";
import classNames from "classnames";
import {getRouteSearchParams} from "../../../../envs/_current/history";
import {useLocation} from "react-use";
import TooltipApp from "components/TooltipApp";


export const GodWordItem = ({
                                item,
                                labelSize,
                                handleAction = undefined,
                                onVote = undefined,
                                onDevote = undefined,
                                handleDisplayById
                            }) => {

    const t = useTranslate()
    const location = useLocation();
    const array = _.split(item?.hashtags, ',')
    const tags = _.isEmpty(item?.hashtags) ? [] : array;
    let searchParams = getRouteSearchParams();

    return renderIf(
        !!item?.source_text || !!item?.content,
        <div className="p-3 flex flex-col gap-1 border-t border-color-50 background shadow-md hover:scale-2xs rounded-xl relative">
            <div className="flex items-center gap-2">
                <GiSpellBook size={11} className="text-color-300"/>
                <span className="font-bold text-xs text-color-000 leading-tight flex-1">
            {item?.source_text}
        </span>
            </div>
            <Link
                to={{pathname: getLinkToDetail(item)}}
                className={classNames("py-1 text-color-100 italic leading-snug cursor-pointer no-underline", labelSize)}>
                {item?.content}
            </Link>
            {renderIf(
                tags.length > 0,
                <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                    {tags.map((e, i) => {
                        searchParams.set("wog_hashtags", e)
                        return (
                            <Link key={i}
                                  to={{
                                      pathname: location.pathname,
                                      search: '?' + searchParams.toString(),
                                  }}
                                  style={{height: 22, padding: '2px 10px', borderRadius: 999}}
                                  className="w-fit flex flex-center border border-blue-300 hover:border-primary font-medium text-2xs text-blue-500 italic leading-tight no-underline">
                                {`#${e}`}
                            </Link>
                        )
                    })}
                    {renderIf(
                        !!!item?.active,
                        <span
                            style={{position: 'absolute', bottom: 5, right: 10}}
                            className="font-medium text-2xs text-orange-500 italic leading-snug">
                  {t('inactive')}
              </span>
                    )}
                </div>
            )}
            <div className="absolute flex items-center gap-2 top-5 right-5">
                {renderIf(
                    item?.edit && handleAction,
                    <TooltipApp title={t('edit words of god')} classNames={{root: "font-medium text-xs italic"}}>
                        <HeaderButton
                            onClick={() => {
                                handleAction(CRUD.UPDATE, item)
                            }}
                            width={22}
                            height={22}
                            icon={<FiEdit3 size={10}/>}
                        />
                    </TooltipApp>
                )}
                {renderIf(
                    item?.edit && handleAction,
                    <TooltipApp title={t('remove words of god')} classNames={{root: "font-medium text-xs italic"}}>
                        <HeaderButton
                            onClick={() => {
                                handleAction(CRUD.DELETE, item)
                            }}
                            width={22}
                            height={22}
                            icon={<BiTrash size={12}/>}
                        />
                    </TooltipApp>
                )}
                {
                    renderIf(
                        onDevote && onVote,
                        <React.Fragment>
                            {renderIfElse(
                                !!item?.vote_status && onDevote && onVote,
                                <TooltipApp title={t('dislike')} placement="topRight"
                                            classNames={{root: "font-medium text-xs italic"}}>
                                    <HeaderButton
                                        onClick={() => {
                                            onDevote({owner_type: 'god_word', owner_id: item?.id})
                                        }}
                                        width={22}
                                        height={22}
                                        icon={<IoHeartSharp size={12}/>}
                                    />
                                </TooltipApp>,
                                <HeaderButton
                                    onClick={() => {
                                        onVote({owner_type: 'god_word', owner_id: item?.id})
                                    }}
                                    width={22}
                                    height={22}
                                    icon={<IoHeartOutline size={12}/>}
                                />
                            )}
                        </React.Fragment>
                    )
                }
            </div>
        </div>
    )
}
